import { AppCacheStatus, MatchingUserAppCacheStatus } from '@fullstory/redux';
import { assertExhaustive } from '@fullstory/typeutils';

export enum ButtonStatus {
  hidden,
  isFetching,
  hasData,
  done,
  fetchFailed,
}

export const matchingUserStatusToButtonStatus = (
  status: MatchingUserAppCacheStatus,
): ButtonStatus => {
  switch (status) {
    case MatchingUserAppCacheStatus.initial:
      return ButtonStatus.hidden;
    case MatchingUserAppCacheStatus.isRefetching:
      return ButtonStatus.isFetching;
    case MatchingUserAppCacheStatus.isLoading:
      return ButtonStatus.isFetching;
    case MatchingUserAppCacheStatus.hasData:
      return ButtonStatus.hasData;
    case MatchingUserAppCacheStatus.loadFailed:
      return ButtonStatus.fetchFailed;
    case MatchingUserAppCacheStatus.fresh:
      return ButtonStatus.done;
    case MatchingUserAppCacheStatus.middle:
      // this state should not be visible because a request will be dispatched
      // immediately after being in the middle state
      return ButtonStatus.done;
    case MatchingUserAppCacheStatus.hidden:
      return ButtonStatus.hidden;
    default:
      assertExhaustive(status);
  }
};

export const appCacheStatusToButtonStatus = (status: AppCacheStatus): ButtonStatus => {
  switch (status) {
    case AppCacheStatus.IsRefetching:
      return ButtonStatus.isFetching;
    case AppCacheStatus.IsLoading:
      return ButtonStatus.isFetching;
    case AppCacheStatus.HasData:
      return ButtonStatus.hasData;
    case AppCacheStatus.LoadFailed:
      return ButtonStatus.fetchFailed;
    case AppCacheStatus.Fresh:
      return ButtonStatus.done;
    case AppCacheStatus.Initial:
      return ButtonStatus.hidden;
    default:
      assertExhaustive(status);
  }
};
